import { ServiceAccount } from "../../schema/types/serviceAccount/entity";
import { linksOf } from "../../services/cpln";
import { parseLink } from "../../utils/linkParser/linkParser";

export interface ServiceAccountTableItem extends ServiceAccount {
  selfLink: string;
}

interface GetServiceAccountTableItemProps {
  link?: string;
  name?: string;
  item?: ServiceAccount;
}
export function getServiceAccountTableItem({
  link,
  name,
  item,
}: GetServiceAccountTableItemProps): ServiceAccountTableItem {
  if (item) {
    const selfLink = linksOf(item).self!;

    return {
      ...item,
      selfLink: selfLink,
    };
  }

  if (link) {
    const { name } = parseLink(link, { useInputCtx: true });

    return {
      kind: "serviceaccount",
      name: name,
      selfLink: link,
      links: [{ rel: "self", href: link }],
      created: "",
      description: "",
      id: "",
      origin: "default",
      lastModified: "",
      tags: {},
      version: 1,
    };
  }

  // assume name
  return {
    kind: "serviceaccount",
    name: name!,
    selfLink: `TODO test if this breaks`,
    links: [],
    created: "",
    description: "",
    id: "",
    origin: "default",
    lastModified: "",
    tags: {},
    version: 1,
  };
}
